"use client";
import React from 'react';
import { useCopilotAction } from "@copilotkit/react-core";
import { msalAdapter } from '../../store/msalAdapter';
import { CalendarMeetingCard, LoadingView } from '../ui/CalendarMeetingCard';
// Microsoft Graph API base URL
const GRAPH_BASE_URL = 'https://graph.microsoft.com/v1.0';
// Helper function to get access token from store-backed MSAL adapter
const getAccessToken = async () => {
    try {
        // Define required scopes for Calendar operations
        const scopes = [];
        // Get valid token from MSAL adapter (with automatic refresh if needed)
        const accessToken = await msalAdapter.getValidToken(scopes);
        // console.log("🚀 ~ getAccessToken ~ accessToken:", accessToken)
        if (!accessToken) {
            throw new Error('Failed to obtain access token from MSAL store');
        }
        console.log('Access token obtained from store-backed MSAL adapter');
        return accessToken;
        return "eyJ0eXAiOiJKV1QiLCJub25jZSI6ImRqNFlld2ZhWnp0Z2Q0MW1YbHlxSEZ3d09lWHhZRDZEa0t3c0FnRmJuVVUiLCJhbGciOiJSUzI1NiIsIng1dCI6IkNOdjBPSTNSd3FsSEZFVm5hb01Bc2hDSDJYRSIsImtpZCI6IkNOdjBPSTNSd3FsSEZFVm5hb01Bc2hDSDJYRSJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC9jZGI3NTJjYi1iNmFmLTRmZmUtOWM2MC05NDI4NGYxM2VhNmUvIiwiaWF0IjoxNzUwMjE4NDA0LCJuYmYiOjE3NTAyMTg0MDQsImV4cCI6MTc1MDMwNTEwNCwiYWNjdCI6MCwiYWNyIjoiMSIsImFpbyI6IkFVUUF1LzhaQUFBQXcyQXJxTW1iV0hSajJzbWl0QjZhZDFLeG56a2xPVDF2STZ6aXBpcHh1Wkw3ZUF4ZjJEOWJwM0tzSzVDcEVwU0ErR1owVTl6aCt3Qy9VQ3VOd2pnRE5RPT0iLCJhbXIiOlsicHdkIl0sImFwcF9kaXNwbGF5bmFtZSI6IkdyYXBoIEV4cGxvcmVyIiwiYXBwaWQiOiJkZThiYzhiNS1kOWY5LTQ4YjEtYThhZC1iNzQ4ZGE3MjUwNjQiLCJhcHBpZGFjciI6IjAiLCJmYW1pbHlfbmFtZSI6Ik5ndXnhu4VuIEFuaCIsImdpdmVuX25hbWUiOiJUdeG6pW4iLCJpZHR5cCI6InVzZXIiLCJpcGFkZHIiOiIxODMuOTEuNy4zNyIsIm5hbWUiOiJUdeG6pW4gTmd1eeG7hW4gQW5oIiwib2lkIjoiOTYzY2E3MjYtODU0Mi00NjU1LWJjYjgtNjlmOGViZTQ2OTM1IiwicGxhdGYiOiIzIiwicHVpZCI6IjEwMDMyMDAyOTMwOUFDRjQiLCJyaCI6IjEuQVVvQXkxSzN6YS0yX2stY1lKUW9UeFBxYmdNQUFBQUFBQUFBd0FBQUFBQUFBQUNKQUROS0FBLiIsInNjcCI6IkNhbGVuZGFycy5SZWFkIENhbGVuZGFycy5SZWFkLlNoYXJlZCBDYWxlbmRhcnMuUmVhZFdyaXRlLlNoYXJlZCBDb250YWN0cy5SZWFkIG9wZW5pZCBQZW9wbGUuUmVhZCBwcm9maWxlIFVzZXIuUmVhZCBlbWFpbCIsInNpZCI6IjAwNWQxYzA5LTQ3YmMtODI2MC0yYjYyLTc2YjEwZmU3MzYwZCIsInNpZ25pbl9zdGF0ZSI6WyJrbXNpIl0sInN1YiI6Ik5PRk9wTWRoZjVzU0F4UkpXLU5aVjF3cEY5U1I1YjVaLUZwVXFXZE8tRnciLCJ0ZW5hbnRfcmVnaW9uX3Njb3BlIjoiQVMiLCJ0aWQiOiJjZGI3NTJjYi1iNmFmLTRmZmUtOWM2MC05NDI4NGYxM2VhNmUiLCJ1bmlxdWVfbmFtZSI6Im5hdEBiYWFvZC5vbm1pY3Jvc29mdC5jb20iLCJ1cG4iOiJuYXRAYmFhb2Qub25taWNyb3NvZnQuY29tIiwidXRpIjoibEtYOGo2cmVCMC02Q2U5MHdkeWlBQSIsInZlciI6IjEuMCIsIndpZHMiOlsiYjc5ZmJmNGQtM2VmOS00Njg5LTgxNDMtNzZiMTk0ZTg1NTA5Il0sInhtc19jYyI6WyJDUDEiXSwieG1zX2Z0ZCI6ImREcVNlT3JQVnBmRW1mRERsRHZUTEt4OEJzX2xDeGRBU1pOMWp4OUdOQllCYW1Gd1lXNWxZWE4wTFdSemJYTSIsInhtc19pZHJlbCI6IjEgMzAiLCJ4bXNfc3NtIjoiMSIsInhtc19zdCI6eyJzdWIiOiJPUnVMdTE5YW9uUkhqb1pRTUYyck1YdmRxR2NmNWx5anNGSE43YnpobXdFIn0sInhtc190Y2R0IjoxNjgxMDA2MzM5fQ.F9ZJdPnwi4F0zPO4I9wX87MSvnEg_6GKe2Q1i1CUUq8bF5q2FWHnnFq1gmR8pxPBS75QjxhywCcvWWcDLO1m1lFwcNxMZYsM8UaFbVVTGRv5BBB956qRy7aeHDD7J2G8wK5eHannjufSZTDtp11e5RlU6mwud2hyewlRn_VqAJeF4h-dVq9rcHbron6f-1lMldspEQuaz4EmMUi3L48L0oy6nApLRF_XE24jnqzy6Dvh1D9gwTGbDgkWdpCgSW-8Fo42gHzRd0ECyYi6KEbE-yw5Aq0snuaaHAjUnSnDongPXY8zpFFf8NeWrq657tLZGZ-cuYyQf4HV1BCSC15--A";
    }
    catch (error) {
        console.error('Error getting access token from store:', error);
        throw new Error(`Authentication failed: ${error instanceof Error ? error.message : String(error)}`);
    }
};
// Helper function to format date for display
const formatMeetingDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};
// Helper function to format time for display
const formatMeetingTime = (startString, endString) => {
    const start = new Date(startString);
    const end = new Date(endString);
    const startTime = start.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const endTime = end.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    return `${startTime} - ${endTime}`;
};
export function DirectOutlookTools() {
    const [showForm, setShowForm] = React.useState(false);
    const [formResult, setFormResult] = React.useState(null);
    // Get current date and time helper - provides real-time context to AI
    // useCopilotAction({
    //   name: "getCurrentDateTime",
    //   description: "Get the current date and time information for scheduling meetings and appointments",
    //   parameters: [],
    //   handler: async () => {
    //     const now = new Date();
    //     const today = new Date(now);
    //     const tomorrow = new Date(now);
    //     tomorrow.setDate(now.getDate() + 1);
    //     const formatDate = (date: Date) => date.toISOString().split('T')[0];
    //     const formatDateTime = (date: Date) => date.toISOString();
    //     const formatDisplayDate = (date: Date) => date.toLocaleDateString('en-US', {
    //       weekday: 'long',
    //       year: 'numeric',
    //       month: 'long',
    //       day: 'numeric'
    //     });
    //     return {
    //       currentDateTime: formatDateTime(now),
    //       currentDate: formatDate(now),
    //       currentTime: now.toLocaleTimeString('en-US', { hour12: false }),
    //       tomorrowDate: formatDate(tomorrow),
    //       displayDate: formatDisplayDate(now),
    //       tomorrowDisplayDate: formatDisplayDate(tomorrow),
    //       year: now.getFullYear(),
    //       month: now.getMonth() + 1,
    //       day: now.getDate(),
    //       hour: now.getHours(),
    //       minute: now.getMinutes(),
    //       timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    //       message: `Current date and time: ${formatDisplayDate(now)}, ${now.toLocaleTimeString('en-US')} (${Intl.DateTimeFormat().resolvedOptions().timeZone})`
    //     };
    //   },
    //   render: ({ status, result }) => {
    //     if (status === "complete" && result) {
    //       return (
    //         <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 my-4">
    //           <div className="flex items-center space-x-2 mb-2">
    //             <Clock className="w-5 h-5 text-blue-600" />
    //             <h4 className="font-medium text-blue-900">Current Date & Time</h4>
    //           </div>
    //           <div className="space-y-1 text-sm text-blue-800">
    //             <p><strong>Today:</strong> {result.displayDate}</p>
    //             <p><strong>Current Time:</strong> {result.currentTime}</p>
    //             <p><strong>Tomorrow:</strong> {result.tomorrowDisplayDate}</p>
    //             <p><strong>Timezone:</strong> {result.timezone}</p>
    //             <p className="text-xs text-blue-600 mt-2">
    //               Use these dates when creating meetings. Format: YYYY-MM-DD for dates, YYYY-MM-DDTHH:mm:ss for full datetime.
    //             </p>
    //           </div>
    //         </div>
    //       );
    //     }
    //     return <div></div>;
    //   },
    // });
    // Show meeting creation form - Interactive form for creating meetings
    // useCopilotAction({
    //   name: "showCreateMeetingForm",
    //   description: "Show an interactive form for users to create a new Outlook meeting with all details",
    //   parameters: [],
    //   handler: async () => {
    //     setShowForm(true);
    //     setFormResult(null);
    //     return {
    //       _showForm: true,
    //       _message: "Please fill out the form below to create your meeting"
    //     };
    //   },
    //   render: ({ status, result }) => {
    //     if (status === "complete" && result?._showForm && showForm) {
    //       return (
    //         <div className="my-4">
    //           <FormCreateMeeting
    //             onSubmit={async (meetingData) => {
    //               try {
    //                 console.log('Creating meeting with form data:', meetingData);
    //                 const accessToken = await getAccessToken();
    //                 const meetingApiData = {
    //                   subject: meetingData.subject,
    //                   body: {
    //                     contentType: "HTML",
    //                     content: meetingData.body || ""
    //                   },
    //                   start: {
    //                     dateTime: meetingData.startTime,
    //                     timeZone: "UTC"
    //                   },
    //                   end: {
    //                     dateTime: meetingData.endTime,
    //                     timeZone: "UTC"
    //                   },
    //                   attendees: meetingData.attendees.split(',').map(email => ({
    //                     emailAddress: {
    //                       address: email.trim(),
    //                       name: email.trim()
    //                     }
    //                   }))
    //                 };
    //                 const response = await fetch(`${GRAPH_BASE_URL}/me/events`, {
    //                   method: 'POST',
    //                   headers: {
    //                     'Authorization': `Bearer ${accessToken}`,
    //                     'Content-Type': 'application/json',
    //                   },
    //                   body: JSON.stringify(meetingApiData),
    //                 });
    //                 if (!response.ok) {
    //                   const errorData = await response.json();
    //                   throw new Error(`Graph API Error: ${response.status} - ${errorData.error?.message || response.statusText}`);
    //                 }
    //                 const createdMeeting = await response.json();
    //                 console.log('Meeting created successfully via form:', createdMeeting);
    //                 setFormResult({
    //                   ...createdMeeting,
    //                   _originalBody: meetingData.body,
    //                   _success: true
    //                 });
    //                 setShowForm(false);
    //               } catch (error) {
    //                 console.error('Error creating meeting via form:', error);
    //                 setFormResult({
    //                   _error: true,
    //                   _message: `❌ Failed to create meeting: ${error instanceof Error ? error.message : String(error)}`
    //                 });
    //                 setShowForm(false);
    //               }
    //             }}
    //             onCancel={() => {
    //               setShowForm(false);
    //               setFormResult({ _cancelled: true });
    //             }}
    //           />
    //         </div>
    //       );
    //     }
    //     // Show result after form submission
    //     if (formResult) {
    //       if (formResult._error) {
    //         return (
    //           <div className="bg-red-50 border border-red-200 rounded-lg p-4 my-4">
    //             <p className="text-red-800">{formResult._message}</p>
    //           </div>
    //         );
    //       }
    //       if (formResult._success && formResult.start && formResult.end) {
    //         return (
    //           <div className="my-4">
    //             <div className="mb-2">
    //               <p className="text-green-600 font-medium">✅ Meeting created successfully!</p>
    //             </div>
    //             <CalendarMeetingCard
    //               date={formatMeetingDate(formResult.start.dateTime)}
    //               time={formatMeetingTime(formResult.start.dateTime, formResult.end.dateTime)}
    //               meetingName={formResult.subject}
    //               description={formResult._originalBody || "Meeting has been successfully created and added to your calendar."}
    //               attendees={formResult.attendees?.length || 0}
    //               organizer={formResult.organizer?.emailAddress?.name}
    //               isOnlineMeeting={formResult.isOnlineMeeting}
    //               location={formResult.location?.displayName}
    //             />
    //           </div>
    //         );
    //       }
    //       if (formResult._cancelled) {
    //         return (
    //           <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 my-4">
    //             <p className="text-gray-700">Meeting creation cancelled.</p>
    //           </div>
    //         );
    //     }
    //     return <div></div>;
    //   },
    // });
    // Create meeting tool - Direct Graph API call with beautiful card display
    useCopilotAction({
        name: "createOutlookMeetingDirect",
        description: "Create a new Outlook meeting directly via Microsoft Graph API. IMPORTANT: Always use getCurrentDateTime first to get the correct current date and time. Do not use outdated dates like 2023. Use proper ISO format for dates (YYYY-MM-DDTHH:mm:ss).",
        parameters: [
            {
                name: "subject",
                type: "string",
                description: "Meeting subject/title",
                required: true,
            },
            {
                name: "attendees",
                type: "string",
                description: "Email addresses of attendees, comma-separated",
                required: true,
            },
            {
                name: "startTime",
                type: "string",
                description: "Meeting start time in ISO format using CURRENT year (e.g., 2025-01-15T14:00:00). MUST use getCurrentDateTime to get current date first!",
                required: true,
            },
            {
                name: "endTime",
                type: "string",
                description: "Meeting end time in ISO format using CURRENT year (e.g., 2025-01-15T15:00:00). MUST use getCurrentDateTime to get current date first!",
                required: true,
            },
            {
                name: "body",
                type: "string",
                description: "Meeting body/description",
                required: false,
            },
        ],
        handler: async ({ subject, attendees, startTime, endTime, body }) => {
            var _a;
            try {
                console.log('Creating Outlook meeting directly via Graph API:', { subject, attendees, startTime, endTime, body });
                // Validate dates are not in the past or using old years
                const startDate = new Date(startTime);
                const endDate = new Date(endTime);
                const currentYear = new Date().getFullYear();
                if (startDate.getFullYear() < currentYear - 1) {
                    throw new Error(`Invalid start time year (${startDate.getFullYear()}). Please use getCurrentDateTime to get the current date and time first.`);
                }
                if (endDate.getFullYear() < currentYear - 1) {
                    throw new Error(`Invalid end time year (${endDate.getFullYear()}). Please use getCurrentDateTime to get the current date and time first.`);
                }
                if (endDate <= startDate) {
                    throw new Error('End time must be after start time.');
                }
                const accessToken = await getAccessToken();
                const meetingData = {
                    subject,
                    body: {
                        contentType: "HTML",
                        content: body || ""
                    },
                    start: {
                        dateTime: startTime,
                        timeZone: "UTC"
                    },
                    end: {
                        dateTime: endTime,
                        timeZone: "UTC"
                    },
                    attendees: attendees.split(',').map(email => ({
                        emailAddress: {
                            address: email.trim(),
                            name: email.trim()
                        }
                    }))
                };
                const response = await fetch(`${GRAPH_BASE_URL}/me/events`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(meetingData),
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(`Graph API Error: ${response.status} - ${((_a = errorData.error) === null || _a === void 0 ? void 0 : _a.message) || response.statusText}`);
                }
                const result = await response.json();
                console.log('Meeting created successfully via Graph API:', result);
                // Return result object with additional context for render function
                return Object.assign(Object.assign({}, result), { _originalBody: body, _success: true });
            }
            catch (error) {
                console.error('Error creating meeting via Graph API:', error);
                return {
                    _error: true,
                    _message: `❌ Failed to create meeting: ${error instanceof Error ? error.message : String(error)}`
                };
            }
        },
        render: ({ status, result }) => {
            var _a, _b, _c, _d;
            if (status === "executing") {
                return React.createElement(LoadingView, null);
            }
            if (status === "complete" && result) {
                // Handle error responses
                if (result._error) {
                    return (React.createElement("div", { className: "bg-red-50 border border-red-200 rounded-lg p-4 my-4" },
                        React.createElement("p", { className: "text-red-800" }, result._message)));
                }
                // Handle success responses - render meeting card
                if (result._success && result.start && result.end) {
                    return (React.createElement("div", { className: "my-4" },
                        React.createElement(CalendarMeetingCard, { date: formatMeetingDate(result.start.dateTime), time: formatMeetingTime(result.start.dateTime, result.end.dateTime), meetingName: result.subject, description: result._originalBody || "Meeting has been successfully created and added to your calendar.", attendees: ((_a = result.attendees) === null || _a === void 0 ? void 0 : _a.length) > 0 ? result.attendees.length : undefined, organizer: (_c = (_b = result.organizer) === null || _b === void 0 ? void 0 : _b.emailAddress) === null || _c === void 0 ? void 0 : _c.name, isOnlineMeeting: result.isOnlineMeeting, location: (_d = result.location) === null || _d === void 0 ? void 0 : _d.displayName })));
                }
            }
            return React.createElement("div", null);
        },
    });
    // List meetings tool - Direct Graph API call with beautiful cards display
    useCopilotAction({
        name: "listOutlookMeetingsDirect",
        description: "List upcoming Outlook meetings directly via Microsoft Graph API",
        parameters: [
            {
                name: "days",
                type: "number",
                description: "Number of days ahead to look for meetings (default: 7)",
                required: false,
            },
        ],
        handler: async ({ days = 7 }) => {
            var _a;
            try {
                console.log('Listing Outlook meetings directly via Graph API for next', days, 'days');
                const accessToken = await getAccessToken();
                const startTime = new Date();
                const endTime = new Date();
                endTime.setDate(startTime.getDate() + days);
                const url = `${GRAPH_BASE_URL}/me/calendarview` +
                    `?startDateTime=${startTime.toISOString()}` +
                    `&endDateTime=${endTime.toISOString()}` +
                    `&$select=subject,start,end,attendees,organizer,location,isOnlineMeeting,body` +
                    `&$orderby=start/dateTime`;
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(`Graph API Error: ${response.status} - ${((_a = errorData.error) === null || _a === void 0 ? void 0 : _a.message) || response.statusText}`);
                }
                const data = await response.json();
                console.log('Meetings retrieved successfully via Graph API:', data);
                const meetings = data.value || [];
                return {
                    _success: true,
                    meetings: meetings,
                    days: days
                };
            }
            catch (error) {
                console.error('Error listing meetings via Graph API:', error);
                return {
                    _error: true,
                    _message: `❌ Failed to retrieve meetings: ${error instanceof Error ? error.message : String(error)}`
                };
            }
        },
        render: ({ status, result }) => {
            if (status === "executing") {
                return React.createElement(LoadingView, null);
            }
            if (status === "complete" && result) {
                // Handle error responses
                if (result._error) {
                    return (React.createElement("div", { className: "bg-red-50 border border-red-200 rounded-lg p-4 my-4" },
                        React.createElement("p", { className: "text-red-800" }, result._message)));
                }
                // Handle success responses - render meeting cards
                if (result._success && result.meetings) {
                    const meetings = result.meetings;
                    if (meetings.length === 0) {
                        return (React.createElement("div", { className: "bg-blue-50 border border-blue-200 rounded-lg p-4 my-4" },
                            React.createElement("p", { className: "text-blue-800" },
                                "\uD83D\uDCC5 No meetings found in the next ",
                                result.days,
                                " days.")));
                    }
                    return (React.createElement("div", { className: "my-4" },
                        React.createElement("h3", { className: "text-lg font-semibold text-gray-800 mb-4" },
                            "\uD83D\uDCC5 Upcoming Meetings (",
                            meetings.length,
                            " found)"),
                        meetings.map((meeting, index) => {
                            var _a, _b, _c, _d, _e;
                            return (React.createElement(CalendarMeetingCard, { key: meeting.id || index, date: formatMeetingDate(meeting.start.dateTime), time: formatMeetingTime(meeting.start.dateTime, meeting.end.dateTime), meetingName: meeting.subject, description: ((_a = meeting.body) === null || _a === void 0 ? void 0 : _a.content) || "No description provided", attendees: ((_b = meeting.attendees) === null || _b === void 0 ? void 0 : _b.length) > 0 ? meeting.attendees.length : undefined, organizer: (_d = (_c = meeting.organizer) === null || _c === void 0 ? void 0 : _c.emailAddress) === null || _d === void 0 ? void 0 : _d.name, isOnlineMeeting: meeting.isOnlineMeeting, location: (_e = meeting.location) === null || _e === void 0 ? void 0 : _e.displayName }));
                        })));
                }
            }
            return React.createElement("div", null);
        },
    });
    // Update meeting tool - Direct Graph API call with beautiful card display  
    useCopilotAction({
        name: "updateOutlookMeetingDirect",
        description: "Update an existing Outlook meeting directly via Microsoft Graph API",
        parameters: [
            {
                name: "meetingId",
                type: "string",
                description: "ID of the meeting to update",
                required: true,
            },
            {
                name: "subject",
                type: "string",
                description: "New meeting subject/title",
                required: false,
            },
            {
                name: "startTime",
                type: "string",
                description: "New start time in ISO format",
                required: false,
            },
            {
                name: "endTime",
                type: "string",
                description: "New end time in ISO format",
                required: false,
            },
            {
                name: "body",
                type: "string",
                description: "New meeting body/description",
                required: false,
            },
        ],
        handler: async ({ meetingId, subject, startTime, endTime, body }) => {
            var _a;
            try {
                console.log('Updating Outlook meeting directly via Graph API:', { meetingId, subject, startTime, endTime, body });
                const accessToken = await getAccessToken();
                const updateData = {};
                if (subject)
                    updateData.subject = subject;
                if (startTime)
                    updateData.start = { dateTime: startTime, timeZone: "UTC" };
                if (endTime)
                    updateData.end = { dateTime: endTime, timeZone: "UTC" };
                if (body !== undefined)
                    updateData.body = { contentType: "HTML", content: body };
                const response = await fetch(`${GRAPH_BASE_URL}/me/events/${meetingId}`, {
                    method: 'PATCH',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(updateData),
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(`Graph API Error: ${response.status} - ${((_a = errorData.error) === null || _a === void 0 ? void 0 : _a.message) || response.statusText}`);
                }
                // Get updated meeting details
                const updatedResponse = await fetch(`${GRAPH_BASE_URL}/me/events/${meetingId}?$select=subject,start,end,attendees,organizer,location,isOnlineMeeting,body`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                });
                if (!updatedResponse.ok) {
                    throw new Error('Failed to retrieve updated meeting details');
                }
                const result = await updatedResponse.json();
                console.log('Meeting updated successfully via Graph API:', result);
                return Object.assign(Object.assign({}, result), { _success: true, _action: 'updated' });
            }
            catch (error) {
                console.error('Error updating meeting via Graph API:', error);
                return {
                    _error: true,
                    _message: `❌ Failed to update meeting: ${error instanceof Error ? error.message : String(error)}`
                };
            }
        },
        render: ({ status, result }) => {
            var _a, _b, _c, _d, _e;
            if (status === "executing") {
                return React.createElement(LoadingView, null);
            }
            if (status === "complete" && result) {
                // Handle error responses
                if (result._error) {
                    return (React.createElement("div", { className: "bg-red-50 border border-red-200 rounded-lg p-4 my-4" },
                        React.createElement("p", { className: "text-red-800" }, result._message)));
                }
                // Handle success responses - render updated meeting card
                if (result._success && result.start && result.end) {
                    return (React.createElement("div", { className: "my-4" },
                        React.createElement("div", { className: "mb-2" },
                            React.createElement("p", { className: "text-green-600 font-medium" }, "\u2705 Meeting updated successfully!")),
                        React.createElement(CalendarMeetingCard, { date: formatMeetingDate(result.start.dateTime), time: formatMeetingTime(result.start.dateTime, result.end.dateTime), meetingName: result.subject, description: ((_a = result.body) === null || _a === void 0 ? void 0 : _a.content) || "Meeting has been updated successfully.", attendees: ((_b = result.attendees) === null || _b === void 0 ? void 0 : _b.length) > 0 ? result.attendees.length : undefined, organizer: (_d = (_c = result.organizer) === null || _c === void 0 ? void 0 : _c.emailAddress) === null || _d === void 0 ? void 0 : _d.name, isOnlineMeeting: result.isOnlineMeeting, location: (_e = result.location) === null || _e === void 0 ? void 0 : _e.displayName })));
                }
            }
            return React.createElement("div", null);
        },
    });
    // Delete meeting tool - Direct Graph API call with confirmation display
    useCopilotAction({
        name: "deleteOutlookMeetingDirect",
        description: "Delete an existing Outlook meeting directly via Microsoft Graph API",
        parameters: [
            {
                name: "meetingId",
                type: "string",
                description: "ID of the meeting to delete",
                required: true,
            },
        ],
        handler: async ({ meetingId }) => {
            var _a;
            try {
                console.log('Deleting Outlook meeting directly via Graph API:', meetingId);
                const accessToken = await getAccessToken();
                // First get meeting details before deleting
                const getResponse = await fetch(`${GRAPH_BASE_URL}/me/events/${meetingId}?$select=subject,start,end,attendees,organizer,location,isOnlineMeeting`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                });
                let meetingDetails = null;
                if (getResponse.ok) {
                    meetingDetails = await getResponse.json();
                }
                // Delete the meeting
                const response = await fetch(`${GRAPH_BASE_URL}/me/events/${meetingId}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                    },
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(`Graph API Error: ${response.status} - ${((_a = errorData.error) === null || _a === void 0 ? void 0 : _a.message) || response.statusText}`);
                }
                console.log('Meeting deleted successfully via Graph API');
                return {
                    _success: true,
                    _action: 'deleted',
                    _meetingDetails: meetingDetails
                };
            }
            catch (error) {
                console.error('Error deleting meeting via Graph API:', error);
                return {
                    _error: true,
                    _message: `❌ Failed to delete meeting: ${error instanceof Error ? error.message : String(error)}`
                };
            }
        },
        render: ({ status, result }) => {
            if (status === "executing") {
                return React.createElement(LoadingView, null);
            }
            if (status === "complete" && result) {
                // Handle error responses
                if (result._error) {
                    return (React.createElement("div", { className: "bg-red-50 border border-red-200 rounded-lg p-4 my-4" },
                        React.createElement("p", { className: "text-red-800" }, result._message)));
                }
                // Handle success responses - show deleted meeting info
                if (result._success) {
                    return (React.createElement("div", { className: "my-4" },
                        React.createElement("div", { className: "bg-green-50 border border-green-200 rounded-lg p-4" },
                            React.createElement("div", { className: "flex items-center space-x-2 mb-2" },
                                React.createElement("span", { className: "text-green-600" }, "\u2705"),
                                React.createElement("p", { className: "text-green-800 font-medium" }, "Meeting deleted successfully!")),
                            result._meetingDetails && (React.createElement("div", { className: "text-sm text-gray-600 mt-2" },
                                React.createElement("p", null,
                                    React.createElement("strong", null, "Deleted:"),
                                    " ",
                                    result._meetingDetails.subject),
                                React.createElement("p", null,
                                    React.createElement("strong", null, "Date:"),
                                    " ",
                                    formatMeetingDate(result._meetingDetails.start.dateTime)),
                                React.createElement("p", null,
                                    React.createElement("strong", null, "Time:"),
                                    " ",
                                    formatMeetingTime(result._meetingDetails.start.dateTime, result._meetingDetails.end.dateTime)))))));
                }
            }
            return React.createElement("div", null);
        },
    });
    return null; // This component doesn't render anything
}
